import $ from "jquery";

const togglePassword = () => {
    const init = () => {
        execute();
    };

    const execute = () => {
        const el = {
            button: ".js-showHidePassword",
        };

        $(document).on("click", el.button, function (e) {
            e.preventDefault();
            const targetEl = $(this).data("for");
            $(`#${targetEl}`).attr("type", (_, type) =>
                type === "text" ? "password" : "text"
            );

            $(this).toggleClass("opened");
        });
    };

    init();
};

try {
    togglePassword();
} catch (error) {
    console.error("togglePassword: ", togglePassword);
}
